//
//
//
//
//
//

  export default {
    name: "plan-construction-info",
    props: ["info"],
    data() {
      return {}
    },
    method: {},
    mounted() {
      this.$nextTick(() => {

      })
    }

  }



// WEBPACK FOOTER //
// ./src/components/PlanConstructionInfo.vue